export default __webpack_public_path__ + "static/media/MFred2.0-Regular.21c86a35.woff";